import * as React from 'react';
import { CancelError } from '../../../utilities/async/CancelError';
import { NameDialog } from '../../nameDialog/NameDialog';
import strings from '../../scope/actions/createDocument/DocumentCreator.resx';
import {
  CreateFolderAction as BaseCreateFolderAction,
  ItemCreateFolderAction as BaseItemCreateFolderAction,
  IItemCreateFolderActionProps as IBaseItemCreateFolderActionProps,
  ICreateFolderActionProps as IBaseCreateFolderActionProps
} from '../../base/actions/createFolder/CreateFolderAction';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { ICreateFolderWizardProps } from '../../../controls/createFolderActionControl';
import CreateFolderStrings from './CreateFolder.resx';
import { format } from '@ms/utilities-strings/lib/index';
import { Alert } from '../../accessibility/alert/Alert';
import { connectToItemCache } from '../../decorators/connectToItemCache';

interface ICreateFolderWizardState {
  folderCreated?: string;
}

class CreateFolderWizard extends React.PureComponent<ICreateFolderWizardProps, ICreateFolderWizardState> {
  constructor(props: ICreateFolderWizardProps) {
    super(props);

    this.state = {};
  }

  public render(): JSX.Element {
    const {
      resolve,
      reject,
      onCreateFolder,
      maxLength,
      title,
      validator
    } = this.props;

    const onContinue = async (options: {
      name: string;
    }) => {
      if (onCreateFolder) {
        await onCreateFolder(options);
      }

      this.setState({
        folderCreated: options.name
      });
    };

    const onCancel = async () => {
      reject(new CancelError());
    };

    const {
      folderCreated
    } = this.state;

    return folderCreated ? (
      <Alert onStart={ resolve }>
        { format(CreateFolderStrings.createFolderCompletedFormat, folderCreated) }
      </Alert>
    ) : (
        <NameDialog
          nameFieldAriaLabel={ strings.FolderNamePlaceholder }
          onContinue={ onContinue }
          onCancel={ onCancel }
          title={ title || strings.CreateFolder }
          maxLength={ maxLength }
          continueText={ strings.CreateCommit }
          name=''
          placeHolder={ strings.FolderNamePlaceholder }
          validator={ validator }
        />
      );
  }
}

export type IItemCreateFolderActionProps =
  IDecoratedProps<IBaseItemCreateFolderActionProps, Pick<IBaseItemCreateFolderActionProps, 'createFolderWizard'>, {}>;

export const ItemCreateFolderAction: React.ComponentType<IItemCreateFolderActionProps> =
  connectToItemCache((): Pick<IBaseItemCreateFolderActionProps, 'createFolderWizard'> => {
    return {
      createFolderWizard: CreateFolderWizard
    };
  })(BaseItemCreateFolderAction);

export type ICreateFolderActionProps =
  IDecoratedProps<IBaseCreateFolderActionProps, Pick<IBaseCreateFolderActionProps, 'createFolderWizard'>, {}>;

export const CreateFolderAction: React.ComponentType<ICreateFolderActionProps> =
  connectToItemCache((): Pick<IBaseItemCreateFolderActionProps, 'createFolderWizard'> => {
    return {
      createFolderWizard: CreateFolderWizard
    };
  })(BaseCreateFolderAction);
